export const CupMark = ({ className = "w-9 h-9" }) => (
  <img
    src="/images/logo-cup.png"
    alt="Cup Connect cup mark"
    className={`${className} object-contain`}
    data-testid="brand-cup-mark"
  />
);

export const Logo = ({ dark = false, className = "h-10 sm:h-11" }) => (
  <div className="flex items-center" data-testid="brand-logo">
    <img
      src="/images/logo-wordmark.png"
      alt="Cup Connect logo"
      className={`${className} w-auto object-contain transition-transform duration-300 group-hover:-rotate-2 group-hover:scale-105 ${
        dark ? "bg-white rounded-xl px-2.5 py-1.5" : ""
      }`}
    />
  </div>
);
